import { HYDRATE } from 'next-redux-wrapper';
import { THydrateAction } from '~/src/store';

export const SET_TICKET_ITEM = 'SET_TICKET_ITEM';
export const REMOVE_TICKET_ITEM = 'REMOVE_TICKET_ITEM';

export interface IPlan {
    value: number, // Здесь хранится цена
    label: string,
    duration: number | null,
    type: number,
}

export enum ECategories {
    TARIFF = 'tariff',
    ANTIVIRUSES = 'antiviruses',
    PARENT_CONTROL = 'parentControl',
    ROUTERS = 'routers',
    WATCH_EVERYWHERE = 'watchEverywhere',
    VIEW_CONTROL = 'viewControl',
    ADDITIONAL_PRODUCTS = 'additionalProducts',
    CONNECTION = 'connection',
    DECODERS = 'decoders',
}

export interface ITicketItem {
    id: number,
    isSelected: boolean,
    name: string
    price: number,
    promoPrice?: number,
    promoAvailable?: boolean,
    plan?: IPlan,
    plans?: IPlan[],
    image?: string,
    isRequired?: boolean,
}

export interface ICategoryItem {
    [id: string]: ITicketItem,
}

export type TTicketState = {
    [category in ECategories]?: ICategoryItem;
};

const initialState:TTicketState = {};

export type TSetTicketItem = {
    type: typeof SET_TICKET_ITEM,
    payload: TTicketState,
}

export type TRemoveTicketItem = {
    type: typeof REMOVE_TICKET_ITEM,
    payload: TTicketState,
}

export type TActions = TSetTicketItem | TRemoveTicketItem;

export default (state = initialState, action: TActions | THydrateAction): TTicketState => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.ticket };
        case SET_TICKET_ITEM: {
            return {
                ...state,
                ...action.payload,
            };
        }
        case REMOVE_TICKET_ITEM: {
            return {
                ...state,
                ...action.payload,
            };
        }

        default: return state;
    }
};
